import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { extractNumbers, getselectedIds, MakeAxiosRequest } from "../../../utils/handler";
import { phoneRegex } from "../../../Constants";
import { useDispatch } from "react-redux";
import FormFields from "../../../Components/inputs/FormFields";
import { SwalError, SwalSuccess } from "../../../Components/SwalFns";
import { updateProfile } from "../../../features/authSlice";
import { InfoModal } from "../../../Components/modals/InfoModal";
import Loader from "../../../Components/loader/Loader";

function CreateForm(props) {

  const { showModal, closeModal, editKey,listingFn,profileEdit,getResponse,returnData,updateBillingInfo, showMoreInfo=false, isMaxineStar=false } = props;
// console.log(props);

  const methods = useForm();
  const dispatch = useDispatch();
  const { handleSubmit, reset, setValue, watch, trigger, getValues, control } = methods;
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);
  const [prefillDetails, setPrefillDetails] = useState([]);
  const [optionsList, setOptionsList] = useState({
    relations: [],
    gender: [],
  });
  const [imageData, setImageData] = useState();
  const [hasImage, sethasImage] = useState();
  const [showMaxineStarCheckbox, setShowMaxineStarCheckbox] = useState(false);

  const submitUrl =  profileEdit ? '/updateprofile' : (editKey ? '/updateproxy' : '/saveproxy');

  const fetchData = async () => {
    try {
      const options = await MakeAxiosRequest("post", "/getadditionalneeds");
      const genderList = await MakeAxiosRequest("post", "/getgenders");
      const createproxyinfo = await MakeAxiosRequest("post", "/createproxyinfo");
      if(!profileEdit && editKey){
        const edit = await MakeAxiosRequest("post", "/editproxy",{user_proxy_key: editKey});
        setPrefillDetails({...edit.data.proxyData, house_types:edit.data.house_types, pets:edit.data.pets, likes:edit.data.likes, medical_types:edit.data.medical_types});
        // console.log(edit.data.proxyData)
      }else if(profileEdit){
        const profile = await MakeAxiosRequest("post", "/myprofile");
        setPrefillDetails({...profile.data.userdetails,additionalneeds:profile.data.additionalneeds, house_types:profile.data.house_types, pets:profile.data.pets, likes:profile.data.likes, medical_types:profile.data.medical_types})
      }      

      const gender = genderList.data.genders?.map((item) => ({
        id: item.id,
        name: item.gender,
      }));
     
      const relations = options.data.relations?.map((item) => ({
        id: item.id,
        name: item.relation,
      }));
      
      const walletPermission = options.data.wallet_permission;
      const infoMessages = createproxyinfo.data.infoMessages;
      setOptionsList({ relations, gender, walletPermission, infoMessages });
      setIsLoading(false)
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    fetchData();
    setSubmitDisabled(false);
    return () => {
      setSubmitDisabled(false);
      reset();
    };
  }, [showModal]);

  useEffect(() => {
    // console.log(prefillDetails);

    setSubmitDisabled(false);
    
    reset({
      first_name: prefillDetails.first_name || "",
      last_name: prefillDetails.last_name || "",
      email: prefillDetails.email || "",
      phone_number: extractNumbers(prefillDetails.phone_number) || "",
      country_code: prefillDetails.country_code || "",
      gender_id: prefillDetails.gender_id || "",
      proxy_relation_id: prefillDetails.proxy_relation_id || "",
      // maxine_star: prefillDetails.maxine_star=='1' || isMaxineStar ? '1' : '0',
    });
    setShowMaxineStarCheckbox(!profileEdit && prefillDetails.show_maxine_star_checkbox!='0')
    // setShowMaxineStarCheckbox(prefillDetails.show_maxine_star_checkbox!='0')
    
    // // Set the medical_information array
    sethasImage(prefillDetails.isdefImage=='0' ? 1 : 0)
  }, [prefillDetails]);


  const createUser = async (data) => {
    // console.log(data);
    // return;
    setSubmitDisabled(true);
    if(updateBillingInfo){
      updateBillingInfo(data);
    }else{
      try {
        data.phone_number = extractNumbers(data.phone_number); 
        data.maxine_star = data.maxine_star==1 ? '1' : '0';
        const response = await MakeAxiosRequest("post", submitUrl, { ...data, hasImage, ...imageData, user_proxy_key: editKey });
        // console.log(response);
        if (response.status == 1) {
          getResponse && getResponse(response.data,(profileEdit ? 'profile' : (editKey ? 'update' : 'create')));
          returnData && returnData(response.data);
          reset();
          !!returnData || closeModal();
          listingFn && listingFn();
          if(response.data?.msg_key =='subText'){
            SwalSuccess({subText: response.data?.message, showbtn:true})
          }else{
            SwalSuccess({ msg: response.message});
          }
          profileEdit && dispatch(updateProfile());
        } else if (response.status == 0) {
          SwalError({ msg: response.message });
        } else {
          // setError('phone_number', { type: 'custom', message: response.message });
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
    setSubmitDisabled(false);
  };
  
  
  const fields = [
    {
      name: "hasImage",
      type: "profileImage",
      className: "text-center mb-4",
      imagePath: prefillDetails?.image_path||prefillDetails?.profile_image,
      hasImage: hasImage,
      sethasImage: sethasImage,
      setImageData: setImageData,
      hideRemovebtn: !isSubmitDisabled,
      isShow: !getResponse && !showMoreInfo,
    },
    
    {
      name: "first_name",
      label: "First Name",
      className: "col-md-6 mb-3",
      rules: { required: "Please enter first name" },
      type: "inputfield",
      isShow: !showMoreInfo,
    },
    {
      name: "last_name",
      label: "Last Name",
      className: "col-md-6 mb-3",
      rules: { required: "Please enter last name" },
      type: "inputfield",
      isShow: !showMoreInfo,
    },
    {
      name: "proxy_relation_id",
      label: "This person is my :",
      className: "col-md-6 mb-3",
      rules: { required: "Please select relation" },
      type: "select",
      options: optionsList.relations,
      isShow: profileEdit ? false : true,
    },
    {
      name: "email",
      label: "Email",
      className: "col-md-6 mb-3",
      rules: { required: "Please enter email" },
      type: "inputfield",
      isShow: profileEdit ? !showMoreInfo : false,
    },
    {
      name: "nick_name",
      label: "Nickname",
      className: "col-md-6 mb-3",
      // rules: { required: "Please enter nick name" },
      type: "inputfield",
      isShow: false,
    },
    {
      name: "phone_number",
      label: "Phone Number",
      className: "col-md-6 mb-3",
      rules: {
        required: "Please enter phone number",
        pattern: {
          value: phoneRegex,
          message: "Please enter a valid phone number",
        },
        ...(!editKey && !profileEdit && {
        validate: {
          existCheck: async (fieldValue) => {
            const response = await MakeAxiosRequest("post","/searchproxybyphone",{ phone_number: extractNumbers(fieldValue) });
            return response?.status == 1 || response?.message;
          },
        },
      }),
      },
      isdisabled: !!editKey || !!profileEdit,
      mask: "(999) 999-9999",
      type: "numberfield",
      isShow: profileEdit ? !showMoreInfo : false,
    },
    {
      name: "gender_id",
      label: "Gender",
      className: "col-md-6 mb-3",
      rules: { required: "Please select gender" },
      type: "select",
      options: optionsList.gender,
      isShow: profileEdit ? !showMoreInfo : false,
    },
    {
      name: "maxine_star",
      label: "Would you be ordering services for this person (Maxine Star)?",
      info: <InfoModal {...optionsList.infoMessages?.find(itm=>itm.type==='maxine_star')}/>,
      className: "col-12 mb-3",
      type: "agreeButton",
      isShow: showMaxineStarCheckbox ,
    },
    
  ];
  
  if(isLoading) return <Loader />;
  return (
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(createUser)}>
          <div className="text-center">
            <h3 className="modal-title">
            {
              getResponse 
                ? (profileEdit ? 'User Info' : 'Relationship Info') 
                : (profileEdit ? (showMoreInfo ? 'Great!' : 'Edit Profile') : (editKey ? 'Edit Relationship' : 'Create Relationship'))
            }
            </h3>
            {showMoreInfo && <p>Tell us more about yourself</p>}
          </div>
          <div className="form-group mt-4">
            <div className="row">
              <FormFields fields={fields} />
            </div>
          </div>
          <div className="mt-4">
            <button
              type="submit"
              className="btn btn-primary rounded-pill w-100 p-2"
              disabled={isSubmitDisabled}
            >
              {profileEdit ? 'Save Account': (editKey ? 'Update' : 'Submit')}
            </button>
          </div>
        </form>
      </FormProvider>
  );
}

export default CreateForm;
